"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentList = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importStar(require("react"));

var Block_1 = require("../Block");

var LoadingIndicators_1 = require("../LoadingIndicators");

var Row_1 = require("../Row");

var FragmentCalendarView_1 = require("./FragmentCalendarView");

var FragmentGridView_1 = require("./FragmentGridView");

var FragmentListView_1 = require("./FragmentListView");

var types_1 = require("./types");

function FragmentList(_a) {
  var sections = _a.sections,
      filters = _a.filters,
      _a$emptyContent = _a.emptyContent,
      emptyContent = _a$emptyContent === void 0 ? react_1.default.createElement(antd_1.Empty, null) : _a$emptyContent,
      forceMode = _a.forceMode,
      getRowData = _a.getRowData,
      tableProps = _a.tableProps,
      loading = _a.loading,
      otherProps = __rest(_a, ["sections", "filters", "emptyContent", "forceMode", "getRowData", "tableProps", "loading"]);

  var listMode = new URLSearchParams(window.location.search).get('view');

  var _ref = (0, react_1.useState)(types_1.FragmentListMode.GRID),
      _ref2 = _slicedToArray(_ref, 2),
      selectedMode = _ref2[0],
      setSelectedMode = _ref2[1];

  (0, react_1.useEffect)(function () {
    if (forceMode !== undefined) {
      setSelectedMode(forceMode);
    }
  }, [forceMode]);
  (0, react_1.useEffect)(function () {
    if (otherProps.refetch) {
      otherProps.refetch(null);
    }
  }, [selectedMode]);
  (0, react_1.useEffect)(function () {
    _setSelectedMode(listMode !== undefined ? Number(listMode) : types_1.FragmentListMode.GRID);
  }, [listMode]);

  var _setSelectedMode = function _setSelectedMode(fragmentView) {
    var params = new URLSearchParams(window.location.search);
    params.set('view', fragmentView.toString());
    var stringParams = params.toString();
    window.history.pushState({}, '', "".concat(window.location.pathname).concat(stringParams ? "?".concat(stringParams) : ''));
    setSelectedMode(fragmentView);
  };

  var modeSelector = react_1.default.createElement(antd_1.Radio.Group, {
    value: selectedMode,
    buttonStyle: 'solid',
    onChange: function onChange(e) {
      return _setSelectedMode(e.target.value);
    }
  }, react_1.default.createElement(antd_1.Radio.Button, {
    value: types_1.FragmentListMode.GRID
  }, react_1.default.createElement(icons_1.AppstoreFilled, null), " Grid"), react_1.default.createElement(antd_1.Radio.Button, {
    value: types_1.FragmentListMode.CALENDAR
  }, react_1.default.createElement(icons_1.CalendarOutlined, null), " Calendar"), getRowData ? react_1.default.createElement(antd_1.Radio.Button, {
    value: types_1.FragmentListMode.LIST
  }, react_1.default.createElement(icons_1.MenuOutlined, null), " List") : null);
  var content = null;

  if (selectedMode === types_1.FragmentListMode.GRID) {
    content = react_1.default.createElement(FragmentGridView_1.FragmentGridView, Object.assign({
      sections: sections
    }, otherProps));
  } else if (selectedMode === types_1.FragmentListMode.LIST) {
    content = react_1.default.createElement(FragmentListView_1.FragmentListView, Object.assign({
      sections: sections,
      getRowData: getRowData,
      tableProps: tableProps
    }, otherProps));
  } else if (selectedMode === types_1.FragmentListMode.CALENDAR) {
    content = react_1.default.createElement(FragmentCalendarView_1.FragmentCalendarView, Object.assign({
      headerLeft: filters,
      sections: sections
    }, otherProps, {
      headerRight: forceMode !== undefined ? undefined : modeSelector
    }));
  }

  return react_1.default.createElement(react_1.default.Fragment, null, selectedMode !== types_1.FragmentListMode.CALENDAR && (filters || forceMode === undefined) ? react_1.default.createElement(Block_1.Block, {
    marginBottom: '@size-m'
  }, react_1.default.createElement(Row_1.Row, {
    align: 'middle'
  }, react_1.default.createElement(antd_1.Col, {
    xs: 24,
    md: 16
  }, filters), forceMode !== undefined ? null : react_1.default.createElement(antd_1.Col, {
    xs: 24,
    md: 8,
    style: {
      textAlign: 'right'
    }
  }, modeSelector))) : null, loading ? react_1.default.createElement(LoadingIndicators_1.BlockSpin, null) : sections.length && sections.some(function (sec) {
    return sec.items.length;
  }) || selectedMode !== types_1.FragmentListMode.GRID ? content : emptyContent);
}

exports.FragmentList = FragmentList;